import angular from 'angular';

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('devices', {
    url: '/devices',
    templateProvider: () =>
      import(/* webpackChunkName: "devices" */ './devices.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'devicesCtrl as vm',
    requiredPermission: 'devices',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "devices" */ './devices.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
      gpsSuppliers: GpsSuppliers => GpsSuppliers.find().$promise,
      account: Account => Account.find({
        filter: {
          fields: { id: true, username: true },
        },
      }).$promise.then(),
    },
  });
}

export default angular.module('app.devices.routing', []).config(routes);
